<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="open = false">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full sm:p-6">
                <div>
                    <CustomTabs>
                        <CustomTab title="From Newbridge Roundabout">
                            <div class="mx-auto flex items-center justify-center h-96 min-h-96 max-w-96">
                                <img src="/images/maps/fslcap-map-newbridge.jpg" alt="A map showing directions to the carpark" class="max-w-full max-h-full h-96">
                            </div>

                            <DialogTitle as="h3" class="text-lg text-left leading-6 font-medium text-gray-900 p-4">
                                Directions from Newbridge Roundabout
                            </DialogTitle>

                            <div class="px-8">
                                <ul class="list-disc">
                                    <li>At Newbridge Roundabout, take the exit onto Old Liston Rd/B7030</li>
                                    <li>Drive passed McDonald's and the BP Petrol Station</li>
                                    <li>Turn LEFT onto Cliftonhall Rd/B7030</li>
                                    <li>Drive passed Greggs the Bakers and then take the FIRST LEFT onto Harvest Rd</li>
                                    <li>Drive under the bridge.</li>
                                    <li>Take FIRST LEFT onto Harvest Dr, Scotmid Building is on the corner.</li>
                                    <li>Take FIRST LEFT onto Queen Anne Drive, Comms World is on the corner.</li>
                                    <li>Drive to the END of Queen Anne Drive and you have arrived at the Car Park</li>
                                </ul>
                            </div>
                        </CustomTab>
                        <CustomTab title="From Glasgow Road A8">
                            <div class="mx-auto flex items-center justify-center min-h-96 h-96">
                                <img src="/images/maps/fslcap-map-glasgow-rd.jpg" alt="A map showing directions to the carpark" class="max-w-full h-full">
                            </div>

                            <DialogTitle as="h3" class="text-lg text-left leading-6 font-medium text-gray-900 p-4">
                                Directions from Glasgow Road A8
                            </DialogTitle>

                            <div class="px-8">
                                <ul class="list-disc">
                                    <li>Heading WEST on Glasgow Rd drive passed RATHO STATION sign</li>
                                    <li>After the footbridge take FIRST LEFT at Travel Lodge corner into Station Road</li>
                                    <li>Drive passed Scotmid Shop</li>
                                    <li>Take FIRST RIGHT into Queen Anne Drive</li>
                                    <li>Take FIRST RIGHT into Queen Anne Drive, Comms World is on the corner.</li>
                                    <li>Drive to the END of Queen Anne Drive and you have arrived at the Car Park</li>
                                </ul>
                            </div>
                        </CustomTab>
                    </CustomTabs>

                    <div class="text-center">

                        <button type="button"
                            class="mt-3 inline-flex px-40 justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-ap-fs-primary text-base font-medium text-white hover:bg-ap-fs-primary-darkened sm:text-sm"
                            @click="open = false">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue';
import CustomTab from './CustomTab.vue';
import CustomTabs from './CustomTabs.vue';

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CustomTabs,
        CustomTab,
    },
    props: ['isOpen'],
    data() {
        return {
            open: false,
        };
    },
    watch: {
        isOpen(val) {
            this.open = val;
        },
        open(val) {
            if (!val) this.$emit('close');
        },
    },
    emits: ['close'],
};
</script>
